// extracted by mini-css-extract-plugin
export default {"Work":"work_Work__pE5Ok","Work_resize":"work_Work_resize__ihOYf","Work_resize_block":"work_Work_resize_block__B5WwE"};